import { Controller } from "@hotwired/stimulus"

// The recipe filters, as a sheet on a narrow screen.
//
// A native <dialog> with showModal(), the same choice nav_drawer and the
// confirm dialog make, and for the same reason: it takes focus, traps it,
// closes on Escape and paints its own backdrop. A hand-rolled overlay has to
// reimplement all four and usually gets the trap wrong.
//
// NOTHING HERE APPLIES A FILTER. The pills inside are ordinary links into
// the Turbo frame, exactly as they are in the desktop rail — this controller
// only opens and shuts the panel. That is why there is no Apply button and
// no local state to reconcile: pressing a pill navigates the frame, the
// sheet's own markup is replaced along with it, and the counts on every
// other pill are correct because the server recomputed them.
//
// The design drew an Apply button carrying "Show 14 recipes", on the
// argument that applying per tap churns a list you cannot see behind the
// panel. That holds where the sheet applies filters itself. Here the frame
// swap redraws the sheet in place with fresh counts, so each tap answers
// itself — "Dinner 14" is the same information the Apply button was going to
// carry, on the control you just pressed.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // A CLICK ON THE BACKDROP CLOSES IT. <dialog> paints the backdrop but does
  // not act on it, and the click lands on the dialog element itself rather
  // than on anything inside — so anywhere outside the panel's own box is
  // outside the sheet.
  //
  // Measured against the modal component's own bug: a drag that STARTS
  // inside and ends outside fires a click on the common ancestor, which
  // closed the panel while you were selecting text. Comparing coordinates
  // rather than event targets avoids it.
  closeOnBackdrop(event) {
    if (event.target !== this.dialogTarget) return

    const box = this.dialogTarget.getBoundingClientRect()
    const inside =
      event.clientX >= box.left &&
      event.clientX <= box.right &&
      event.clientY >= box.top &&
      event.clientY <= box.bottom

    if (!inside) this.close()
  }
}
